import { useEffect, useRef, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

// Hooks
import useParameterUrl from "./../../../../../@utility/hooks/useParameterUrl";
import setBodyScroll from "./../../../../../@utility/app/setBodyScroll";

// Redux
import { setDataAlert } from "./../../../../../@core/redux/actions/app/alert";
import { openAuthenApp } from "./../../../../../@core/redux/actions/auth/index";

// auth
import { isUserLoggedIn } from "./../../../../../@core/auth/utils";

// Services
// import { login, loginLine } from "./../../../../../@core/auth/jwt/jwtService";

// Component
import LogoApp from "./../Logo";
import ModalApp from "./../ModalFull";
import ModalAlert from "./../Alert/ModalAlert";
import LoginApp from "./Login";
import RegisterApp from "./Register";
import RememberApp from "./Remember";
// import AuthStep from "./step";
import LoadContent from "./../LoadContent";
import SnackbarSet from "./../SnackbarSet";

//  CSS
import styles from "./../../assets/css/Style.module.css";
import buttonStyles from "./../../assets/css/Button.module.css";
import formStyles from "./../../assets/css/Input.module.css";

function AuthApp() {
    const childRef = useRef();
    const parsed = useParameterUrl();
    const auth = useSelector(state => state.reduxAuth);
    const dispatch = useDispatch();
    const [step, setStep] = useState(1);
    const [process, setProcess] = useState(false);
    const [data, setData] = useState(undefined);
    // อยู่ระหว่างขั้นตอนยืนยัน OTP ไหม — Register เป็นคนบอกขึ้นมา
    // เก็บใน ref ไม่ใช่ state เพราะไม่ได้ใช้ render และ onShow / onStepChange ต้องอ่านค่าล่าสุดในจังหวะที่ถูกเรียก
    // ตอนยืนยัน OTP สำเร็จ Register ปลดธงแล้วสั่งปิด modal ต่อกันทันที ถ้าเป็น state ค่าจะยังเป็นของเดิม
    // แล้วจะเด้ง "ออกจากขั้นตอนยืนยันรหัส OTP ?" ทั้งที่สมัครสำเร็จไปแล้ว
    const otpProcessRef = useRef(false);
    const setOtpProcess = (val) => {
        otpProcessRef.current = val;
    };
    // null = ไม่ได้ถาม · "close" = กดปิด modal · "back" = กดปุ่มย้อนกลับบนหัว modal
    const [confirmExit, setConfirmExit] = useState(null);
    let { code } = parsed;
    // const [lineCode, setLineCode] = useState( (code !== undefined && code !== "") ? code : "");

    // เปิดใช้งาน Auth
    const onShow = (val) => {
        // ปิด modal ทิ้งระหว่างยืนยัน OTP = ต้องขอรหัสใหม่ ถามก่อน
        if (val === false && otpProcessRef.current) {
            // ModalFull.close() ปลดล็อก scroll ไปก่อนเรียกตัวนี้แล้ว แต่ยังไม่ได้ปิดจริง ต้องล็อกคืน
            setBodyScroll(true);
            setConfirmExit("close");
            return;
        }

        dispatch(openAuthenApp({ ...auth, show: val }));
    };

    // ปุ่มย้อนกลับบนหัว modal — ระหว่างยืนยัน OTP ต้องถามก่อนเหมือนกัน
    const onStepChange = (val) => {
        if (val < step && otpProcessRef.current) {
            setConfirmExit("back");
            return;
        }

        setStep(val);
    };

    // ปิด dialog ยืนยัน โดยที่ modal ใหญ่ยังเปิดอยู่
    // ModalAlert ปลดล็อก scroll ตอนปิดตัวเอง ต้องล็อกคืน ไม่งั้นพื้นหลังเลื่อนได้ทั้งที่ยังอยู่หน้ากรอก OTP
    const closeConfirmExit = () => {
        setConfirmExit(null);
        setBodyScroll(true);
    };

    // ยืนยันว่าจะออกจริง
    // ปิด modal → Register ถูก unmount สถานะ OTP หายทั้งชุด
    // ย้อนกลับ → ลด step ลง Register จับจังหวะนี้แล้วล้างสถานะ OTP ให้เอง
    const leaveOtp = () => {
        const action = confirmExit;
        setConfirmExit(null);
        setOtpProcess(false);

        if (action === "back") {
            setStep(1);
            setBodyScroll(true);
            return;
        }

        dispatch(openAuthenApp({ ...auth, show: false }));
    };

    // เปลีย่นช่องทาง
    const switchChanel = (val) => {
        // setData(undefined)
        dispatch(openAuthenApp({ ...auth, tab: val }));
    };

    const alertMsg = async (da) => {
        childRef.current.snackbar(da);
    }

    useEffect(() => {

        // ตรวจสอบว่ามีการเข้าสู้ระบบหรือไม่
        if (isUserLoggedIn()) {
            dispatch(openAuthenApp({
                tab: "login",
                show: false
            }));
        }

        setStep(1)
    }, [auth.show, dispatch]);

    return (
        <>
            <SnackbarSet ref={childRef} />
            <ModalApp show={auth.show} onShow={onShow} step={step} onStep={onStepChange} disable={process}>
                {
                    auth.tab !== "remember" ?
                        <>
                            <div className="center">
                                <LogoApp />
                            </div>

                            {/* {
                                (!process && auth.tab !== "register") && (
                                    <div className="center">
                                        <LogoApp />
                                    </div>
                                )
                            } */}

                            {/* {auth.tab === "register" && !process ?
                                <>
                                    <br />
                                    <Grid container justifyContent="center"><AuthStep currented={step} total={3} /></Grid>
                                </> : null
                            } */}

                            {(step === 1 || auth.tab === "login") && !process ?
                                <Grid container justifyContent="space-between" alignItems="center" style={{ marginTop: "20px" }} spacing={2}>
                                    <Grid item xs={6}>
                                        <div onClick={() => switchChanel('login')} className={[buttonStyles.btnLogin, auth.tab === "login" ? buttonStyles.btnOrange : buttonStyles.btnOutline].join(" ")} >
                                            เข้าสู่ระบบ
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <div onClick={() => switchChanel('register')} className={[buttonStyles.btnLogin, auth.tab === "register" ? buttonStyles.btnOrange : buttonStyles.btnOutline].join(" ")} >
                                            สมัครสมาชิก
                                        </div>
                                    </Grid>
                                </Grid> : null
                            }

                            {auth.tab === "login" ? <LoginApp data={data} onData={setData} onShow={onShow} alert={alertMsg} switchChanel={switchChanel} codeLine={code} onProcess={setProcess} process={process} /> : null}
                            {auth.tab === "register" ? <RegisterApp data={data} onData={setData} onShow={onShow} alert={alertMsg} onProcess={setProcess} process={process} step={step} onStep={setStep} setDataAlert={setDataAlert} onOtpProcess={setOtpProcess} /> : null}
                        </>
                        :
                        <RememberApp onShow={onShow} alert={alertMsg} switchChanel={switchChanel} />
                }

                {process ?
                    <div className={styles.boxContentWidthBig}>
                        <div className={styles.formPadding}>
                            <div className={[styles.boxContentLineTitle, styles.center].join(" ")} style={{ marginTop: "0px" }}>
                                ระบบกำลังตรวจสอบข้อมูล
                            </div>
                            <br />
                            <LoadContent></LoadContent>
                            <div className={styles.processLineText}>
                                กรุณา "<span style={{ color: "#FFF500" }}>ห้ามปิด หรือรีเฟรช</span>" หน้าจอนี้จนกว่าระบบจะทำงานสำเร็จ
                            </div>
                        </div>
                    </div> : null
                }

                {
                    process === false && (
                        <>
                            <br />
                            <div className={[formStyles.inputPaddingTop, "center"].join(" ")}>
                                <div style={{ color: "white", fontSize: "16px" }}>
                                    หากคุณพบปัญหาใด ๆ ในขณะเข้าสู่ระบบ
                                    กรุณาติดต่อ <span style={{ color: "#FF0000" }}>พนักงานบริการลูกค้า</span> เพื่อขอความช่วยเหลือเพิ่มเติม
                                </div>
                            </div>
                        </>
                    )
                }

            </ModalApp>

            <ModalAlert show={confirmExit !== null} onShow={closeConfirmExit}>
                <div className={[styles.boxContentLineTitle, styles.center].join(" ")} style={{ marginTop: "0px" }}>
                    ออกจากขั้นตอนยืนยันรหัส OTP ?
                </div>

                <div className={[formStyles.inputPaddingTop, "center"].join(" ")} style={{ color: "white", fontSize: "16px", marginTop: "16px" }}>
                    รหัสที่ส่งไปแล้วจะใช้ไม่ได้ ต้องเริ่มขอรหัสใหม่
                </div>

                <Grid container spacing={2} justifyContent="center" style={{ marginTop: "10px" }}>
                    <Grid item xs={6}>
                        <div className="center">
                            <div className={[buttonStyles.btnLogin, buttonStyles.btnOutline].join(" ")} onClick={closeConfirmExit}>
                                กรอกรหัสต่อ
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className="center">
                            <div className={[buttonStyles.btnLogin, buttonStyles.btnOrange].join(" ")} onClick={leaveOtp}>
                                ออก
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </ModalAlert>
        </>
    );
}

export default AuthApp
